<p-dialog [modal]="true" [(visible)]="visible" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="headless">
        <div class="p-0 flex flex-col bg-[#FFFFFF] rounded-[16px] font-[Gilroy]" *ngIf="!successful">
            <div class="flex w-full justify-between items-center p-4">
                <p class="text-secondary font-semibold text-lg">
                    {{ 'invoice.edit_gas' | transloco }}
                </p>
            </div>

            <div class="flex py-4">
                <div class="h-[2px] bg-secondary w-full"></div>
            </div>

            <p class="px-6">{{ 'admin.numer_of_pdrs' | transloco }}</p>
            <div class="flex w-full justify-between gap-5 mobile:flex-col mobile:justify-normal mobile:items-center">
                <div class="flex items-center space-x-4 p-6 mobile:p-2">
                    <button type="button" (click)="changePdrCount(-1)"
                        class="px-4 py-2 border rounded-[16px] hover:bg-secondary-300">-</button>
                    <span>{{ numberOfPdrs }}</span>
                    <button type="button" (click)="changePdrCount(1)"
                        class="px-4 py-2 border rounded-[16px] hover:bg-secondary-300">+</button>
                </div>

                <div class="h-[45px] w-[300px] px-6 mobile:p-2">
                    <app-custom-button buttonText="{{ 'admin.reset' | transloco }}" (buttonClick)="resetDialogData()"
                        backgroundColor="bg-error-300" textColor="text-neutral" borderColor="border-neutral"
                        hoverBackgroundColor="hover:bg-error-800" hoverTextColor="hover:text-black"
                        hoverBorderColor="hover:border-neutral">
                    </app-custom-button>
                </div>
            </div>

            <div class="flex flex-col gap-4 px-6 overflow-y-auto max-h-[60vh] mobile:max-h-[50dvh]">

                <div class="flex gap-2 flex-wrap items-end">
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]" labelText="ID"
                            [inputId]="'invoiceNumber'" [inputType]="'text'" [(inputValue)]="invoiceIdInput"
                            [errorMessage]="invoiceIdError" placeholder="ID">
                        </app-labeled-input>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'archive.overview.file_name' | transloco }}" [inputId]="'invoiceNumber'"
                            [inputType]="'text'" [(inputValue)]="invoiceFileNameInput" [errorMessage]="invoiceIdError"
                            placeholder="{{ 'archive.overview.file_name' | transloco }}">
                        </app-labeled-input>
                    </div>
                </div>

                <!-- Location -->
                <div class="flex gap-2 flex-wrap items-end">
                    <!-- Street -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.street' | transloco }}" [inputId]="'street'"
                            [inputType]="'text'" [(inputValue)]="streetInput" [errorMessage]="streetInputError"
                            placeholder="{{ 'shared.placeholders.street' | transloco }}">
                        </app-labeled-input>
                    </div>

                    <!-- Number -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.street_number' | transloco }}" [inputId]="'number'"
                            [inputType]="'text'" [(inputValue)]="numberInput" [errorMessage]="numberInputError"
                            placeholder="{{ 'shared.placeholders.street_number' | transloco }}">
                        </app-labeled-input>
                    </div>

                    <!-- Postal Code -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.postal_code' | transloco }}" [inputId]="'postalCode'"
                            [inputType]="'text'" [(inputValue)]="postalCodeInput" [errorMessage]="postalCodeInputError"
                            placeholder="{{ 'shared.placeholders.postal_code' | transloco }}">
                        </app-labeled-input>
                    </div>

                    <!-- City -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.city' | transloco }}" [inputId]="'city'" [inputType]="'text'"
                            [(inputValue)]="cityInput" [errorMessage]="cityInputError"
                            placeholder="{{ 'shared.placeholders.city' | transloco }}">
                        </app-labeled-input>
                    </div>

                    <!-- Province -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.province' | transloco }}" [inputId]="'province'"
                            [inputType]="'text'" [(inputValue)]="provinceInput" [errorMessage]="provinceInputError"
                            placeholder="{{ 'shared.placeholders.province' | transloco }}">
                        </app-labeled-input>
                    </div>

                    <!-- Latitude -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.coordinates.lat' | transloco }}" [inputId]="'latitude'"
                            [inputType]="'text'" [(inputValue)]="latitudeInput" [errorMessage]="latitudeInputError"
                            placeholder="{{ 'shared.labels.coordinates.lat' | transloco }}">
                        </app-custom-number-input>
                    </div>

                    <!-- Longitude -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.coordinates.long' | transloco }}" [inputId]="'longitude'"
                            [inputType]="'text'" [(inputValue)]="longitudeInput" [errorMessage]="longitudeInputError"
                            placeholder="{{ 'shared.labels.coordinates.long' | transloco }}">
                        </app-custom-number-input>
                    </div>
                </div>

                <!-- Base invoice fields -->
                <div class="flex gap-2 flex-wrap items-end">
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.number' | transloco }}" [inputId]="'invoiceNumber'"
                            [inputType]="'text'" [(inputValue)]="invoiceNumberInput"
                            [errorMessage]="invoiceNumberInputError"
                            placeholder="{{ 'invoice.placeholders.number' | transloco }}">
                        </app-labeled-input>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.consumption_class' | transloco }}"
                            [inputId]="'invoiceConsumptionClass'" [inputType]="'text'"
                            [(inputValue)]="invoiceConsumptionClass" [errorMessage]="invoiceConsumptionClassError"
                            placeholder="{{ 'invoice.labels.consumption_class' | transloco }}">
                        </app-labeled-input>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-date-input inputId="forPeriod" labelText="{{ 'invoice.labels.period' | transloco }}"
                            placeholder="{{ 'invoice.placeholders.period' | transloco }}" [(dateValue)]="forPeriodDate"
                            [errorMessage]="forPeriodInputError" dateFormat="mm/yy"
                            boxHeight="min-h-[50px] max-h-[70px]">
                        </app-custom-date-input>
                    </div>
                </div>

                <div class="flex gap-2 flex-wrap items-end">
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.total_consumption' | transloco }} Smc"
                            [inputId]="'totalConsumption'" [inputType]="'number'" [(inputValue)]="totalConsumptionInput"
                            [errorMessage]="totalConsumptionInputError"
                            placeholder="{{ 'invoice.placeholders.total_consumption' | transloco }}">
                        </app-custom-number-input>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.amount_actual' | transloco }}"
                            [inputId]="'invoiceAmountActual'" [inputType]="'number'"
                            [(inputValue)]="invoiceAmountActualInput" [errorMessage]="invoiceAmountActualInputError"
                            placeholder="{{ 'invoice.placeholders.amount' | transloco }}">
                        </app-custom-number-input>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.amount_gross' | transloco }}" [inputId]="'invoiceAmountGross'"
                            [inputType]="'number'" [(inputValue)]="invoiceAmountGrossInput"
                            [errorMessage]="invoiceAmountGrossInputError"
                            placeholder="{{ 'invoice.placeholders.amount' | transloco }}">
                        </app-custom-number-input>
                    </div>
                </div>

                <div class="flex gap-2 flex-wrap items-end">
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.vat_rate' | transloco }}" [inputId]="'invoiceVatRate'"
                            placeholder="{{ 'invoice.placeholders.enter_as_decimal' | transloco }}" [inputType]="'text'"
                            [(inputValue)]="vatRateInput" [errorMessage]="vatRateInputError">
                        </app-custom-number-input>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.vat_amount' | transloco }}" [inputId]="'invoiceVatAmount'"
                            [inputType]="'text'" [(inputValue)]="vatAmountInput" [errorMessage]="vatAmountInputError">
                        </app-custom-number-input>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.nontaxable_amount' | transloco }}"
                            [inputId]="'nontaxableAmount'" [inputType]="'number'" [(inputValue)]="nontaxableAmountInput"
                            [errorMessage]="nontaxableAmountInputError">
                        </app-custom-number-input>
                    </div>
                </div>

                <!-- PDRs -->
                <div *ngFor="let pdr of editedPDRs; let i = index" class="border border-border rounded-xl p-4 my-6">
                    <p class="text-primary text-lg font-semibold mb-4">
                        {{ 'invoice.sections.pdr_number' | transloco }} {{ i + 1 }}
                    </p>

                    <!-- Location -->
                    <div class="flex gap-2 flex-wrap items-end">
                        <!-- Street -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.labels.street' | transloco }}" [inputId]="'street' + i"
                                [inputType]="'text'" [(inputValue)]="editedPDRs[i].location.street"
                                placeholder="{{ 'shared.placeholders.street' | transloco }}">
                            </app-labeled-input>
                        </div>

                        <!-- Number -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.labels.street_number' | transloco }}" [inputId]="'number' + i"
                                [inputType]="'text'" [(inputValue)]="editedPDRs[i].location.number"
                                placeholder="{{ 'shared.placeholders.street_number' | transloco }}">
                            </app-labeled-input>
                        </div>

                        <!-- Postal Code -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.labels.postal_code' | transloco }}" [inputId]="'postalCode' + i"
                                [inputType]="'text'" [(inputValue)]="editedPDRs[i].location.postal_code"
                                placeholder="{{ 'shared.placeholders.postal_code' | transloco }}">
                            </app-labeled-input>
                        </div>

                        <!-- City -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.labels.city' | transloco }}" [inputId]="'city' + i"
                                [inputType]="'text'" [(inputValue)]="editedPDRs[i].location.city"
                                placeholder="{{ 'shared.placeholders.city' | transloco }}">
                            </app-labeled-input>
                        </div>

                        <!-- Province -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.labels.province' | transloco }}" [inputId]="'province' + i"
                                [inputType]="'text'" [(inputValue)]="editedPDRs[i].location.province"
                                placeholder="{{ 'shared.placeholders.province' | transloco }}">
                            </app-labeled-input>
                        </div>
                    </div>

                    <div class="flex gap-2 flex-wrap items-end">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.spread' | transloco }}" [inputId]="'spread_' + i"
                                [inputType]="'number'" [(inputValue)]="editedPDRs[i].spread">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.vat_rate' | transloco }}" [inputId]="'vat_rate_' + i"
                                placeholder="{{ 'invoice.placeholders.enter_as_decimal' | transloco }}"
                                [inputType]="'text'" [(inputValue)]="editedPDRs[i].vat_rate">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.vat_amount' | transloco }}" [inputId]="'vat_amount_' + i"
                                [inputType]="'text'" [(inputValue)]="editedPDRs[i].vat_amount_actual">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.gas_market_price' | transloco }}"
                                [inputId]="'market_price_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].gas_market_price">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_gas_var_actual' | transloco }}"
                                [inputId]="'price_gas_var_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].price_gas_var_actual">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_gas_fix' | transloco }}"
                                [inputId]="'price_gas_fix_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].price_gas_fix">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.hcv_gas' | transloco }}" [inputId]="'hcv_gas_' + i"
                                [inputType]="'number'" [(inputValue)]="editedPDRs[i].hcv_gas">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.taxrate_gas_scale1' | transloco }}"
                                [inputId]="'tax1_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].taxrate_gas_scale1">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.taxrate_gas_scale2' | transloco }}"
                                [inputId]="'tax2_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].taxrate_gas_scale2">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.taxrate_gas_scale3' | transloco }}"
                                [inputId]="'tax3_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].taxrate_gas_scale3">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.taxrate_gas_scale4' | transloco }}"
                                [inputId]="'tax4_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].taxrate_gas_scale4">
                            </app-custom-number-input>
                        </div>
                    </div>

                    <!-- Gas Quantities & Types -->
                    <div class="flex gap-2 flex-wrap items-end mt-6">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.month_gas_consumption' | transloco }}"
                                [inputId]="'month_gas_consumption_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].month_gas_consumption">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.variable_gas_consumption' | transloco }}"
                                [inputId]="'variable_gas_consumption_' + i" [inputType]="'number'"
                                placeholder="{{ 'invoice.placeholders.enter_as_decimal' | transloco }}"
                                [(inputValue)]="editedPDRs[i].variable_gas_consumption">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.fixed_gas_consumption' | transloco }}"
                                [inputId]="'fixed_gas_consumption_' + i" [inputType]="'number'"
                                placeholder="{{ 'invoice.placeholders.enter_as_decimal' | transloco }}"
                                [(inputValue)]="editedPDRs[i].fixed_gas_consumption">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.daily_gas_capacity' | transloco }}"
                                [inputId]="'daily_gas_capacity_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].daily_gas_capacity">
                            </app-custom-number-input>
                        </div>

                        <div class="w-[300px] self-center">
                            <app-custom-dropdown [options]="priceTypeDropdownOptions"
                                label="{{ 'invoice.labels.price_type' | transloco }}"
                                [(selectedOption)]="editedPDRs[i].selectedPriceTypeDropdown" [disabled]="saveClicked"
                                boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-dropdown>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.gas_market_index' | transloco }}"
                                [inputId]="'gas_market_index_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPDRs[i].gas_market_index">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.gas_intensity_class' | transloco }}"
                                [inputId]="'gas_intensity_class_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPDRs[i].gas_intensity_class">
                            </app-labeled-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.gas_meter_class' | transloco }}"
                                [inputId]="'gas_meter_class_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPDRs[i].gas_meter_class">
                            </app-labeled-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.REMI_type_gas' | transloco }}"
                                [inputId]="'REMI_type_gas_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPDRs[i].REMI_type_gas">
                            </app-labeled-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.area_gas' | transloco }}" [inputId]="'area_gas_' + i"
                                [inputType]="'text'" [(inputValue)]="editedPDRs[i].area_gas">
                            </app-labeled-input>
                        </div>
                    </div>

                    <div class="flex gap-2 flex-wrap items-end mt-6">
                        <!-- forecast_index_value -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.forecast_index_value' | transloco }}"
                                [inputId]="'forecast_index_value_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPDRs[i].forecast_index_value">
                            </app-labeled-input>
                        </div>

                        <!-- exercise_tax_type_gas -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.exercise_tax_type_gas' | transloco }}"
                                [inputId]="'exercise_tax_type_gas_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPDRs[i].exercise_tax_type_gas">
                            </app-labeled-input>
                        </div>

                        <!-- tax_type_gas -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.tax_type_gas' | transloco }}"
                                [inputId]="'tax_type_gas_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPDRs[i].tax_type_gas">
                            </app-labeled-input>
                        </div>

                        <!-- pdr_id -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.pdr_id' | transloco }}" [inputId]="'pdr_id_' + i"
                                [inputType]="'text'" [(inputValue)]="editedPDRs[i].pdr_id">
                            </app-labeled-input>
                        </div>
                    </div>

                    <!-- Cost Breakdown -->
                    <div class="flex gap-2 flex-wrap items-end mt-6">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.daily_capacity_factor_gas' | transloco }}"
                                [inputId]="'daily_capacity_factor_gas_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].daily_capacity_factor_gas">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.fixed_charge_gas_actual' | transloco }}"
                                [inputId]="'fixed_charge_gas_actual_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].fixed_charge_gas_actual">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.material_cost_factor' | transloco }}"
                                [inputId]="'material_cost_factor_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].material_cost_factor">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.material_costs_gas_variable_actual' | transloco }}"
                                [inputId]="'material_costs_gas_variable_actual_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].material_costs_gas_variable_actual">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.material_costs_gas_fixed_actual' | transloco }}"
                                [inputId]="'material_costs_gas_fixed_actual_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].material_costs_gas_fixed_actual">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.fixed_distribution_costs_gas_actual' | transloco }}"
                                [inputId]="'fixed_distribution_costs_gas_actual_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].fixed_distribution_costs_gas_actual">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.fixed_distribution_costs_gas_calc' | transloco }}"
                                [inputId]="'fixed_distribution_costs_gas_calc_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].fixed_distribution_costs_gas_calc">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.variable_transportation_fee' | transloco }}"
                                [inputId]="'variable_transportation_fee_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].variable_transportation_fee">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.var_transportation_costs_actual' | transloco }}"
                                [inputId]="'var_transportation_costs_actual_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].var_transportation_costs_actual">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.total_var_distribution_costs_actual' | transloco }}"
                                [inputId]="'total_var_distribution_costs_actual_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].total_var_distribution_costs_actual">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.tms' | transloco }}" [inputId]="'tms' + i"
                                [inputType]="'number'" [(inputValue)]="editedPDRs[i].tms_gas_charges_actual">
                            </app-custom-number-input>
                        </div>
                    </div>

                    <!-- Additional Charges & Status -->
                    <div class="flex gap-2 flex-wrap items-end mt-6">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.total_gas_taxes_actual' | transloco }}"
                                [inputId]="'total_gas_taxes_actual_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].total_gas_taxes_actual">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.additional_gas_charges' | transloco }}"
                                [inputId]="'additional_gas_charges_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].additional_gas_charges">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.total_gas_discount_amount' | transloco }}"
                                [inputId]="'total_gas_discount_amount_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].total_gas_discount_amount">
                            </app-custom-number-input>
                        </div>
                    </div>

                    <!-- Var distribution fee tiers -->
                    <p class="text-sm font-semibold text-primary mt-5">
                        {{ 'invoice.labels.var_distribution_fee_tiers' | transloco }}
                    </p>
                    <div class="flex gap-2 flex-wrap items-end mt-6">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 1"
                                [inputId]="'var_distribution_fee_tier' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].var_distribution_fee_tier1">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 2"
                                [inputId]="'var_distribution_fee_tier' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].var_distribution_fee_tier2">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 3"
                                [inputId]="'var_distribution_fee_tier' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].var_distribution_fee_tier3">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 4"
                                [inputId]="'var_distribution_fee_tier' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].var_distribution_fee_tier4">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 5"
                                [inputId]="'var_distribution_fee_tier' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].var_distribution_fee_tier5">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 6"
                                [inputId]="'var_distribution_fee_tier' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].var_distribution_fee_tier6">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 7"
                                [inputId]="'var_distribution_fee_tier' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].var_distribution_fee_tier7">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 8"
                                [inputId]="'var_distribution_fee_tier' + i" [inputType]="'number'"
                                [(inputValue)]="editedPDRs[i].var_distribution_fee_tier8">
                            </app-custom-number-input>
                        </div>

                    </div>

                    <!-- Supplier data -->
                    <p class="text-sm font-semibold text-primary my-4">
                        {{ 'invoice.sections.supplier_details' | transloco }}
                    </p>

                    <div class="flex gap-2 flex-wrap items-end mb-6">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.supplier_name' | transloco }}"
                                [inputId]="'supplier_name_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPDRs[i].supplierData.name">
                            </app-labeled-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.vat_id' | transloco }}" [inputId]="'vat_id_' + i"
                                [inputType]="'text'" [(inputValue)]="editedPDRs[i].supplierData.vat_id">
                            </app-labeled-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.contact_name' | transloco }}"
                                [inputId]="'contact_name_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPDRs[i].supplierData.contact_name">
                            </app-labeled-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.contact_number' | transloco }}"
                                [inputId]="'contact_number_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPDRs[i].supplierData.contact_number">
                            </app-labeled-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.email' | transloco }}" [inputId]="'email_' + i"
                                [inputType]="'text'" [(inputValue)]="editedPDRs[i].supplierData.email">
                            </app-labeled-input>
                        </div>

                        <app-custom-date-input labelText="{{ 'shared.labels.gas.start_of_supply' | transloco }}"
                            inputId="'supplier_start_of_supply_' + i"
                            placeholder="{{ 'shared.placeholders.gas.start_of_supply' | transloco }}"
                            [(dateValue)]="editedPDRs[i].supplierData.start_of_supply" [errorMessage]="null"
                            [isDisabled]="false" dateFormat="dd/mm/yy" boxHeight="min-h-[50px] max-h-[70px]">
                        </app-custom-date-input>

                        <app-custom-date-input labelText="{{ 'shared.labels.gas.end_of_supply' | transloco }}"
                            inputId="'supplier_end_of_supply_' + i"
                            placeholder="{{ 'shared.placeholders.gas.end_of_supply' | transloco }}"
                            [(dateValue)]="editedPDRs[i].supplierData.end_of_supply" [errorMessage]="null"
                            [isDisabled]="false" dateFormat="dd/mm/yy" boxHeight="min-h-[50px] max-h-[70px]">
                        </app-custom-date-input>

                    </div>
                </div>
            </div>

            <div *ngIf="dialogErrorMessage" class="text-error text-sm mt-2">
                {{ dialogErrorMessage }}
            </div>

            <!-- Action Buttons -->
            <div class="flex w-full gap-4 p-6 justify-center">
                <div class="flex-[1] h-[45px] min-w-[150px] max-w-[500px]">
                    <app-custom-button buttonText="{{ 'shared.cancel' | transloco }}" (buttonClick)="closeModal()"
                        backgroundColor="bg-[#FFFFFF]" textColor="text-secondary" borderColor="border-secondary"
                        hoverBackgroundColor="hover:bg-secondary" hoverBorderColor="hover:border-secondary">
                    </app-custom-button>
                </div>

                <div class="flex-[1] h-[45px] min-w-[150px] max-w-[500px]">
                    <app-custom-button buttonText="{{ 'admin.copy' | transloco }}" (buttonClick)="copyJson()"
                        backgroundColor="bg-[#FFFFFF]" textColor="text-primary" borderColor="border-primary"
                        hoverBackgroundColor="hover:bg-primary" hoverBorderColor="hover:border-primary">
                    </app-custom-button>
                </div>

                <div class="flex-[1] h-[45px] min-w-[150px] max-w-[500px]">
                    <app-custom-button buttonText="{{ 'shared.download' | transloco }}" (buttonClick)="downloadJson()"
                        backgroundColor="bg-[#FFFFFF]" textColor="text-neutral" borderColor="border-neutral"
                        hoverBackgroundColor="hover:bg-primary-1500" hoverTextColor="hover:text-black"
                        hoverBorderColor="hover:border-neutral">
                    </app-custom-button>
                </div>

                <div class="flex-[1] h-[45px] min-w-[150px] max-w-[500px]">
                    <app-custom-button buttonText="{{ 'shared.save' | transloco }}" (buttonClick)="saveJson()"
                        backgroundColor="bg-success" textColor="text-neutral" borderColor="border-neutral"
                        hoverBackgroundColor="hover:bg-success-300" hoverTextColor="hover:text-black"
                        hoverBorderColor="hover:border-neutral">
                    </app-custom-button>
                </div>
            </div>
        </div>
    </ng-template>
</p-dialog>